module.exports = __webpack_public_path__ + "static/media/lock.92c13b70.png";